import { Injectable } from '@angular/core';

/**
 * ART-19551 AC 2b — native store review, requested after a positive answer.
 *
 * This base is a no-op so any platform without an implementation (and the unit
 * tests) simply do nothing. NativeScript overrides it with `StoreReviewNSService`,
 * which calls `SKStoreReviewController` on iOS and Play In-App Review on Android.
 * Web has no equivalent and keeps this default.
 */
/**
 * `providedIn: 'root'` rather than an entry in the `SERVICES` array.
 *
 * `SharedModule` lists `SERVICES` in its `@NgModule.providers`, not only in
 * `forRoot()`, so anything in that array is re-provided inside every lazy module
 * that imports it. That gave each lazy module its own no-op instance, which
 * shadowed the `StoreReviewNSService` override registered at the root — the sheet
 * is presented from the lazily loaded dashboard, so it silently got the no-op.
 *
 * As a tree-shakable root provider there is exactly one default, and the explicit
 * provider in `NSModule.forRoot()` overrides it everywhere.
 */
@Injectable({ providedIn: 'root' })
export class StoreReviewService {
  public requestReview(): Promise<void> {
    return Promise.resolve();
  }
}
